module.exports = __webpack_public_path__ + "assets/img/SEOClarity-Landing-Page-+-Website-w960.8c3ae780.webp";